export var getEventsCollections = function getEventsCollections(state) {
  return state.events.collections;
};
export var getSchemas = function getSchemas(state) {
  return state.events.schemas;
};
export var getSchemaLoading = function getSchemaLoading(state, colletion) {
  return state.events.loadingSchemas.includes(colletion);
};
export var getCollectionSchema = function getCollectionSchema(state, collection) {
  var schema = state.events.schemas[collection];
  return schema || {
    schema: {},
    list: [],
    tree: {}
  };
};